import { PageHeading, UserRoleHeading } from '@/components/Layout/Parts';
import useHasPermission from '@/hooks/useHasPermission';

import VacationApprovalTable from './components/VacationApprovalTable';

const VacationApprovals = () => {
  const isHrUser = useHasPermission('manage freelancers');

  return (
    <>
      <UserRoleHeading>{isHrUser ? 'Hr User' : 'Team Lead'}</UserRoleHeading>
      <PageHeading>Vacation Approvals</PageHeading>
      <VacationApprovalTable />
    </>
  );
};

export default VacationApprovals;
